import { AuditMatch, toDateTimeStr, toTimestamp } from '@mi-front/core';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { IconButton, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { useCopyQuickShareURLFromParams } from '../../../logger/screens/stream/hooks/selection/useSelectionActions';

export function ShareButton(p: { match: AuditMatch }) {
  const { match } = p;
  const { $t } = useIntl();
  const copyQuickShareURLFromParams = useCopyQuickShareURLFromParams();

  const tooltipMsg = $t({
    id: 'logger.streamScreen.selectionMenu.copyQuickShare',
    defaultMessage: 'Copiar URL Quick Share',
  });

  const generateUrlToShare = () => {
    copyQuickShareURLFromParams({
      $t: $t,
      startTime: match.datetime,
      endTime: toDateTimeStr(toTimestamp(match.datetime) + match.audio!.duration),
      title: match.audio?.title,
    });
  };

  return (
    <Tooltip title={tooltipMsg}>
      <IconButton size="small" color="primary" onClick={generateUrlToShare}>
        <InsertLinkIcon />
      </IconButton>
    </Tooltip>
  );
}
